import styled from 'styled-components';
import { LOADER_TRANSITION_IN_DURATION_MILLIS } from './constants';
import { DelayedLoaderStyleProps } from './types';

const transitionStyles = {
  entering: 'opacity: 1;',
  entered: 'opacity: 1;',
  exiting: 'opacity: 0;',
  exited: 'opacity: 0;',
  unmounted: '',
};

export const Container = styled.span<DelayedLoaderStyleProps>`
  ${(props) => {
    if (!props.$animate) {
      return undefined;
    }

    const { $delayMillis, $transitionStatus } = props;

    return `
      transition: opacity ${LOADER_TRANSITION_IN_DURATION_MILLIS}ms ease-in ${$delayMillis}ms;
      ${transitionStyles[$transitionStatus]}
    `;
  }}
`;
